import * as CryptoJS from 'crypto-js';

export class EncryptionService {
  private readonly secretKey: string = 'VExFVzJPMldOV3NSTkFQaE8zaHhkSWRKZjE1VWNWVXg=';

  // Encrypt a string
  encrypt(data: string): string {
    const ciphertext = CryptoJS.AES.encrypt(data, this.secretKey);
    return ciphertext.toString();
  }

  // Decrypt a string
  decrypt(encryptedData: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
